import { adjustedFlowActionTypes, launchActionTypes } from '@constants/actionTypes/ssapActionTypes';
import { changeData } from '@actions/ssap/ssapActionCreators';
import { PAGES } from '@constants/ssap/flows/pagesTypes';
import { getFirstHhmIdxWithJobIncomeMissingEmployerName } from '@utils/ssap/incomeEmployerNameUtils';

export const MIDDLEWARE_ON_INTERCEPT_ACTION = {
    type: launchActionTypes.CUSTOM_MIDDLEWARE_FLOW_ADJUSTMENT_COMPLETED
};

export const customMiddleware = store => next => action => {
    if(action.type === adjustedFlowActionTypes.ADJUST_FLOW && action.isEqual === true) {

        store.dispatch(MIDDLEWARE_ON_INTERCEPT_ACTION);

        const {
            adjustedFlow,
            data
        } = store.getState().ssap;

        const reopenedForEditing = data.reopenedForEditing;

        if(reopenedForEditing) {
            const eligibleAptcPageIndex = adjustedFlow
                .findIndex(p => p.pageName === PAGES.RECONCILIATION_IN_APTC_PAGE && p.isActive);

            const eligibleOtherCoveragePageIndex = adjustedFlow
                .findIndex(p => p.pageName === PAGES.OTHER_HEALTH_COVERAGE_PAGE && p.isActive);


            const hhmIdxWithJobIncomeMissingSourceName = getFirstHhmIdxWithJobIncomeMissingEmployerName(data);

            const incomesPageIndexWithError = hhmIdxWithJobIncomeMissingSourceName === null
                ? -1
                : adjustedFlow
                    .findIndex(p => p.pageName === PAGES.INCOME_SOURCES_PAGE && p.isActive && p.hhm === hhmIdxWithJobIncomeMissingSourceName);



            const validIndexes = [
                eligibleOtherCoveragePageIndex,
                eligibleAptcPageIndex,
                incomesPageIndexWithError
            ].filter(i => i !== -1);

            const dataWithAdjustedMaxAchievedPage = {
                ...data,
                maxAchievedPage: validIndexes.length > 0 ? Math.min(...validIndexes) : data.maxAchievedPage,
                reopenedForEditing: false
            };

            store.dispatch(changeData(dataWithAdjustedMaxAchievedPage));
        }
    }

    next(action);
};